'use client'
import styled from 'styled-components'

export const FilterLayoutContainerStyled = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  row-gap: 19px;
  justify-content: space-between;
  height: auto;
  width: 100%;

  @media screen and (max-width: 576px) {
    position: static;
    flex-wrap: wrap;
    flex-direction: row;
    z-index: auto;
    box-shadow: none;
    height: auto;
    margin-top: 0;
    row-gap: 11px;
  }
`

export const ProductAmountStyled = styled.div`
  color: #9d9d9d;
  font-weight: var(--typography-weight-bold);
  font-size: var(--typography-size-s3);
  line-height: var(--typography-size-m2);
  margin-left: var(--spacing-margin-xxSmall);
`

export const TitleStyled = styled.div`
  display: flex;
  align-items: center;

  .label {
    color: black;
    font-size: var(--typography-size-m2);
    font-weight: var(--typography-weight-semiRegular);
    line-height: var(--typography-size-l1);
    margin: 0;
    padding: 0;
    span {
      font-weight: var(--typography-weight-bold);
    }
  }
`
